import executeRequests from './lib/execute-requests.js'
import handleResponses from './lib/handle-responses.js'
import setContextOriginal from './set-context-original.js'

// When you save, you have the option of updating and mutating the
// context object, typically checking values off the `form.$` object.
// Then, when the requests are resolved, you need to re-apply the
// original pre-form mutator if the page uses one.
export default ({ component, page, preSaveMutator, preFormMutator }) => ({ detail: { context } }) => {

    if (preSaveMutator) {
        // Example use would be where '$.isChecked' toggles some string:
        //
        //   if (!context.form.$.isCustomLocation) {
        //       context.form.game.attributes.customLocation = removeProperty
        //   }
        //
        preSaveMutator({ context })
    }
    component.$set({ saving: true })
    return executeRequests({ component, page, context })
        .then(responses => {
            const { alerts, errors, updatedForm } = handleResponses({ page, responses, context })

            component.$set(setContextOriginal({
                context: {
                    errors: errors && errors.length ? errors : [],
                    alerts: alerts && alerts.length ? alerts : [],
                    form: (alerts && alerts.length) || (errors && errors.length) ? context.form : updatedForm,
                    view: context.view
                }
            }, preFormMutator))

            component.$set({ saving: false })

            if (alerts && alerts.length > 0) {
                return Promise.reject(alerts)
            }

            return responses
        })
}
